import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StartingScreen.css';
import { doctorTypes } from '../constants';

const StartingScreen = () => {
  const navigate = useNavigate();

  const handleButtonClick = (contextId) => {

    if (window.ReactNativeWebView) {
      const currentUrl = window.location.origin;
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'ROUTE',
          url: currentUrl + `/chat?contextId=${encodeURIComponent(contextId)}`,
        }),
      );
    } else {
      navigate(`/chat?contextId=${encodeURIComponent(contextId)}`);
    }
  };

  return (
    <div className='starting-screen'>
      <div className='buttons-container'>
        {Object.entries(doctorTypes).map(([contextId, text]) => {
          const [specialty, scenario] = text.split(": ");
          return (
            <button key={contextId} className='doctor-button' onClick={() => handleButtonClick(contextId)}>
              <div className='doctor-text'>
                <p className="specialty">{specialty}</p>
                <p className="scenario">Сценарий: {scenario}</p>
              </div>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 3.99918L14 9.99918L8 15.9992" stroke="#05b2e6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StartingScreen;
